import React, { useState } from 'react';
import { format } from 'date-fns';
import { CalendarDays } from 'lucide-react';
import { Calendar } from '../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

const isPastOrToday = (day) => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return day <= today;
};

export const InstallDatePicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const select = (day) => {
    onChange(day);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex h-10 w-full items-center rounded-md border border-gray-300 bg-white px-3 text-left text-sm hover:border-yellow-400 transition-colors"
          data-testid="booking-date-trigger"
        >
          <CalendarDays className="w-4 h-4 mr-2 text-yellow-500" />
          <span className={value ? 'text-gray-900' : 'text-gray-500'} data-testid="booking-date-value">
            {value ? format(value, 'EEEE, MMMM d, yyyy') : 'Pick your install date'}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[200]" align="start" data-testid="booking-date-calendar">
        <Calendar mode="single" selected={value} onSelect={select} disabled={isPastOrToday} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
